import { Injectable } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ErrorHandlerService {
    constructor(private translations: TranslateService) {}

    public getErrorMessage(error, entityType?: string) {
        return this.prepareErrorMessage(error, entityType);
    }

    private prepareErrorMessage(error, entityType?: string) {
        switch (error.status) {
            case 400:
                error.statusText = this.translations.instant('ERRORS.400_STATUS_TEXT');
                break;
            case 401:
                error.statusText = this.translations.instant('ERRORS.401_STATUS_TEXT');
                break;
            case 403:
                error.statusText =
                    entityType && entityType === 'events'
                        ? this.translations.instant('ERRORS.403_EVENTS_STATUS_TEXT')
                        : this.translations.instant('ERRORS.403_STATUS_TEXT');
                break;
            case 404:
                error.statusText = this.translations.instant('ERRORS.404_STATUS_TEXT');
                break;
            case 408:
                error.statusText = this.translations.instant('ERRORS.408_STATUS_TEXT');
                break;
            case 500:
                error.statusText = this.translations.instant('ERRORS.500_STATUS_TEXT');
                break;
            case 502:
                error.statusText = this.translations.instant('ERRORS.502_STATUS_TEXT');
                break;
            case 504:
                error.statusText = this.translations.instant('ERRORS.504_STATUS_TEXT');
                break;
            default:
                error.statusText = this.translations.instant('ERRORS.DEFAULT_STATUS_TEXT');
        }
        return error;
    }
}
